import { instanceValue } from '@wix/wix-instance-parser-js';
import { parseQueryParams } from '@wix/panda-js-utils';
export const getLinguisticHeaderFromUrl = (url) => {
    const { lang, dateNumberFormat, isPrimaryLanguage, instance } = parseQueryParams(url);
    if (lang && dateNumberFormat && isPrimaryLanguage) {
        const instanceId = instanceValue.getValueFromInstance('instanceId', instance);
        return `${getLastLangValue(lang)}|${dateNumberFormat}|${isPrimaryLanguage}|${instanceId}`;
    }
};
const getLastLangValue = (lang) => {
    if (typeof lang === 'string') {
        return lang;
    }
    return lang.pop();
};
//# sourceMappingURL=linguistic-header.js.map